import { render, staticRenderFns } from "./ColposcopyHistoryTable.vue?vue&type=template&id=eced9606&"
import script from "./ColposcopyHistoryTable.vue?vue&type=script&lang=js&"
export * from "./ColposcopyHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports